// extracted by mini-css-extract-plugin
export default {"itemsCard":"CardWorkItems_itemsCard__Wf9dw"};